import { gql, useLazyQuery } from '@apollo/client';

export interface UserValue {
  id: string;
  key: string;
  value: string;
  index: string;
  createdAt: string;
}

export const USERVALUE_FIELDS = gql`
  fragment UserValueFields on UserValue {
    id
    key
    value
    index
    createdAt
  }
`;

export const GET_USER_VALUES = gql`
  ${USERVALUE_FIELDS}
  query GetUserValues($companyId: String, $token: String) {
    getUserValues(companyId: $companyId, token: $token) {
      ...UserValueFields
    }
  }
`;

export interface GetUserValuesResult {
  getUserValues: UserValue[];
}

// Enforce that either companyId or token must be provided (but not both)
export type GetUserValuesInput = { companyId: string; token?: never } | { companyId?: never; token: string };

export function useUserValuesQuery() {
  return useLazyQuery<GetUserValuesResult, GetUserValuesInput>(GET_USER_VALUES, {});
}
